module.exports = __webpack_public_path__ + "img/logo_nacional.40eda899.png";